var v = "5.8.1";
var fr = 29.9700012207031;
var ip = 0;
var op = 90.0000036657751;
var w = 468;
var h = 468;
var nm = "Lock";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Key",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    233.875,
                    278.462,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 1,
                                        y: 1
                                    },
                                    o: {
                                        x: 1,
                                        y: 0
                                    },
                                    t: 42,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    0,
                                                    1.63
                                                ],
                                                [
                                                    0,
                                                    0.87
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                },
                                {
                                    i: {
                                        x: 0.527,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.747,
                                        y: 0
                                    },
                                    t: 44,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    0,
                                                    -14.62
                                                ],
                                                [
                                                    0,
                                                    15.87
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                },
                                {
                                    t: 47.0000019143492,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    0,
                                                    -10.87
                                                ],
                                                [
                                                    0,
                                                    10.87
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.0941176489,
                                0.580392181873,
                                0.909803926945,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 22.544,
                            ix: 5
                        },
                        lc: 2,
                        lj: 1,
                        ml: 10,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 0,
                    k: 100,
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 42.0000017106951,
        op: 308.000012545097,
        st: 8.00000032584668,
        bm: 0
    },
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Body",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    278.713,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 40,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    12.05,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    12.05
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -12.05,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -12.05
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -12.05,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -12.05
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    12.05,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    12.05
                                                ]
                                            ],
                                            v: [
                                                [
                                                    67.231,
                                                    55.484
                                                ],
                                                [
                                                    -67.231,
                                                    55.484
                                                ],
                                                [
                                                    -89.05,
                                                    33.665
                                                ],
                                                [
                                                    -89.05,
                                                    -33.665
                                                ],
                                                [
                                                    -67.231,
                                                    -55.484
                                                ],
                                                [
                                                    67.231,
                                                    -55.484
                                                ],
                                                [
                                                    89.05,
                                                    -33.665
                                                ],
                                                [
                                                    89.05,
                                                    33.665
                                                ]
                                            ],
                                            c: true
                                        }
                                    ]
                                },
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 42,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    12.05,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    12.05
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -12.05,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -12.05
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -12.05,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -12.05
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    12.05,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    12.05
                                                ]
                                            ],
                                            v: [
                                                [
                                                    67.231,
                                                    55.484
                                                ],
                                                [
                                                    -67.231,
                                                    55.484
                                                ],
                                                [
                                                    -89.05,
                                                    33.665
                                                ],
                                                [
                                                    -89.05,
                                                    -23.665
                                                ],
                                                [
                                                    -67.231,
                                                    -45.484
                                                ],
                                                [
                                                    67.231,
                                                    -45.484
                                                ],
                                                [
                                                    89.05,
                                                    -23.665
                                                ],
                                                [
                                                    89.05,
                                                    33.665
                                                ]
                                            ],
                                            c: true
                                        }
                                    ]
                                },
                                {
                                    t: 46.0000018736184,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    12.05,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    12.05
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -12.05,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -12.05
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -12.05,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -12.05
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    12.05,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    12.05
                                                ]
                                            ],
                                            v: [
                                                [
                                                    67.231,
                                                    55.484
                                                ],
                                                [
                                                    -67.231,
                                                    55.484
                                                ],
                                                [
                                                    -89.05,
                                                    33.665
                                                ],
                                                [
                                                    -89.05,
                                                    -33.665
                                                ],
                                                [
                                                    -67.231,
                                                    -55.484
                                                ],
                                                [
                                                    67.231,
                                                    -55.484
                                                ],
                                                [
                                                    89.05,
                                                    -33.665
                                                ],
                                                [
                                                    89.05,
                                                    33.665
                                                ]
                                            ],
                                            c: true
                                        }
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.0941176489,
                                0.580392181873,
                                0.909803926945,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 22.544,
                            ix: 5
                        },
                        lc: 2,
                        lj: 1,
                        ml: 10,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.615
                                ],
                                y: [
                                    1.001
                                ]
                            },
                            o: {
                                x: [
                                    0.783
                                ],
                                y: [
                                    -3e-3
                                ]
                            },
                            t: 24,
                            s: [
                                50
                            ]
                        },
                        {
                            t: 38.0000015477717,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.615
                                ],
                                y: [
                                    0.999
                                ]
                            },
                            o: {
                                x: [
                                    0.783
                                ],
                                y: [
                                    0.003
                                ]
                            },
                            t: 24,
                            s: [
                                50
                            ]
                        },
                        {
                            t: 38.0000015477717,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 224,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            },
            {
                ty: "fl",
                c: {
                    a: 0,
                    k: [
                        0.937254965305,
                        0.968627512455,
                        1,
                        1
                    ],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                bm: 0,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
            }
        ],
        ip: 0,
        op: 300.00001221925,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Top",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 1,
                k: [
                    {
                        i: {
                            x: 0.667,
                            y: 1
                        },
                        o: {
                            x: 0.333,
                            y: 0
                        },
                        t: 41,
                        s: [
                            278.963,
                            223.229,
                            0
                        ],
                        to: [
                            0,
                            0,
                            0
                        ],
                        ti: [
                            0,
                            0,
                            0
                        ]
                    },
                    {
                        i: {
                            x: 0.667,
                            y: 1
                        },
                        o: {
                            x: 0.333,
                            y: 0
                        },
                        t: 43,
                        s: [
                            278.963,
                            243.229,
                            0
                        ],
                        to: [
                            0,
                            0,
                            0
                        ],
                        ti: [
                            0,
                            0,
                            0
                        ]
                    },
                    {
                        t: 47.0000019143492,
                        s: [
                            278.963,
                            223.229,
                            0
                        ]
                    }
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    44.963,
                    44.587,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -24.832,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -24.832
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -24.832
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        24.832,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -44.963,
                                        44.838
                                    ],
                                    [
                                        -44.963,
                                        0.125
                                    ],
                                    [
                                        0,
                                        -44.838
                                    ],
                                    [
                                        0,
                                        -44.838
                                    ],
                                    [
                                        44.963,
                                        0.125
                                    ],
                                    [
                                        44.963,
                                        44.838
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.0941176489,
                                0.580392181873,
                                0.909803926945,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 22.544,
                            ix: 5
                        },
                        lc: 2,
                        lj: 1,
                        ml: 10,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.914
                                ],
                                y: [
                                    -1e-3
                                ]
                            },
                            t: 35,
                            s: [
                                100
                            ]
                        },
                        {
                            t: 43.0000017514259,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 1
                },
                e: {
                    a: 0,
                    k: 100,
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 1.00000004073083,
        op: 301.000012259981,
        st: 1.00000004073083,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Fill",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 14.0000005702317,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        127.025,
                                        0
                                    ],
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        -127.026,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        127.025,
                                        0
                                    ],
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        -127.026,
                                        0
                                    ],
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        230
                                    ],
                                    [
                                        230,
                                        0
                                    ],
                                    [
                                        0,
                                        -230
                                    ],
                                    [
                                        -230,
                                        0
                                    ],
                                    [
                                        0,
                                        230
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.937254901961,
                                0.96862745098,
                                1,
                                1
                            ],
                            ix: 4
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var Lock = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, Lock as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=Lock.json.es.js.map
